import get from 'lodash/get';

export const providerEvent = (data) => {
  return {
    corporateProviderName:
      get(data, 'corporateProvider.name') || get(data, 'corporateProviderName'),
    taxIdNumber: get(data, 'taxIdNumber.tin') || get(data, 'taxIdNumber'),
    corporateProviderMpin:
      get(data, 'corporateProvider.mpin') || get(data, 'corporateProviderMpin'),
    healthCareOrganization:
      get(data, 'organizationName') || get(data, 'organization.name'),
  };
};
